import { Injectable } from "@angular/core";
import { Capacitor } from "@capacitor/core";

@Injectable({ providedIn: "root" })
export class AppUtils {
  isAndroid(): boolean {
    return this.getPlatform() === "android";
  }

  isIos(): boolean {
    return this.getPlatform() === "ios";
  }

  isWeb(): boolean {
    return this.getPlatform() === "web";
  }

  isWebMobile(): boolean {
    return /Mobi|Android/i.test(navigator.userAgent);
  }

  getPlatform(): string {
    return Capacitor.getPlatform();
  }
}
